import {EventHandlerApi} from './eventHandlerApi'

export default {
  install(Vue, options) {
    const { store } = options.dependencies
    Vue.prototype.$eventHandlerApi = new EventHandlerApi(Vue, store)
  }
}